<form name="HolidayForm" (ngSubmit)="Validate(HolidayForm)" #HolidayForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Holiday</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12 px-1">
                    <label>Holiday Name</label>
                    <input type="text" [maxLength]="100" class="form-control" name="HolidayName" placeholder="Ex. Diwali"
                        [(ngModel)]="HolidayDetail.HolidayName" #HolidayName="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter holiday name !
                    </div>
                </div>

                <div class="col-md-12 px-1 pt-2">
                    <label>Holiday Type</label>
                    <select class="form-control form-select" name="HolidayType" [(ngModel)]="HolidayDetail.HolidayType"
                        #HolidayType="ngModel" required>
                        <option [value]=null hidden disabled>Select Type</option>
                        <option value='State'>State</option>
                        <option value='National'>National</option>
                    </select>
                    <div class="invalid-feedback">
                        Please select holiday type.
                    </div>

                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                    <!-- <div class="form-check">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="HolidayDetail.Active"
                            [name]="'Active'" id="flexCheckDefault">
                        <label class="form-check-label" for="flexCheckDefault">
                            {{ HolidayDetail.Active ? 'Active' : 'Inactive' }}
                        </label>
                    </div> -->
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <button *ngIf="(this.HolidayDetail.ESS_HolidayMasterID == 0 && this.common.PageRight.IsAdd) || (this.HolidayDetail.ESS_HolidayMasterID > 0 && this.common.PageRight.IsEdit)" type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>

                </div>
            </div>
        </div>

    </div>
</form>